module.exports = __webpack_public_path__ + "static/img/banner-2.8ad8dbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-2.jpg
// module id = X8kJ
// module chunks = 1